<template>
  <div class="goods">
    <v-head :title="title"></v-head>
    <div class="contentOffLine">
      <van-cell-group>
        <van-field label-align="top" required :value="getRecommendBranchName(params.recommendUnitId)" is-link readonly
          name="picker" label="推荐单位" placeholder="请选择推荐单位"
          @click="showRecommendBranchPicker('recommendUnitId', undefined)" />
        <van-field label-align="top" required :value="education" is-link readonly name="picker" label="学历"
          placeholder="请选择您的学历" @click="show = true" />

        <van-field label-align="top" required v-model="params.major" label="所学专业" placeholder="请选择所学专业" />
        <van-field label-align="top" required v-model="params.extendExpiryDate" is-link readonly name="datePicker"
          label="学生证有效期（填学生证有效期）" placeholder="点击选择时间" @click="showPicker = true" />
        <van-field label-align="top" required name="uploader" label="学生证明材料(只允许上传图片类型文件，大小不能超过1MB)">
          <template #input>
            <van-uploader v-model="files" accept="image/*" :max-count="1" :after-read="beforeFileUpload"
              @delete="delFile" />
          </template>
        </van-field>
      </van-cell-group>
      <!-- <div style="margin:40px auto; width:60%">
        <van-button type="primary" block @click="submitCreate">提交</van-button>
      </div> -->
    </div>
    <div class="bottomButton">
      <el-button plain @click="reback()" style="margin-right: 20px;">返回</el-button>
      <el-button plain type="primary" @click="submitCreate()">提交申请</el-button>
    </div>
    <!-- 学历弹窗 -->
    <van-action-sheet v-model="show" :actions="options" @select="choiceOfYears" title="请选择您的学历">
    </van-action-sheet>
    <!-- 单位选择弹窗 -->
    <van-popup v-model="selectModel" position="bottom" :style="{ 'min-height': '20%' }">
      <van-picker show-toolbar ref="picker" :value-key="key" :columns="columns" @change="onChange" @cancel="onCancel"
        @confirm="onConfirm" />
    </van-popup>
    <!-- 时间选择弹窗 -->
    <van-popup v-mode="showPicker" position="bottom">
      <van-datetime-picker v-model="currentDate" :min-date="minDate" @confirm="onConfirmDate" type="date"
        @cancel="showPicker = false" />
    </van-popup>
    <van-overlay style="z-index:999" :show="loading" lock-scroll>
      <div class="wrapper">
        正在上传...
      </div>
    </van-overlay>


  </div>
</template>

<script type="text/javascript">
  import vHead from "../../components/Subhead.vue";
  import Exif from "exif-js";
  import { mapState, mapGetters, mapActions } from "vuex";
  import { uploadFile, delFile } from "@/api/upload";
  import {
    Uploader,
    Toast,
    Picker,
    Field,
    Button,
    DatetimePicker,
    Popup,
    Cell,
    CellGroup,
    ActionSheet,
    Dialog,
    RadioGroup,
    Radio,
    Overlay
  } from "vant";
  import {
    getDictionaryByCode,
    getUser,
    getDuesList,
    getGroupDues,
    memberAudit,
    createOrder,
    getBranchs,
    applyReduction,
    getBase64
  } from "@/api/dictionary";
  import { getSessionStore } from "@/utils/sessionStorage.js";
  export default {
    data() {
      return {
        show: false,
        loading: false,
        title: "填写资料",
        options: [],
        education: '',
        currentDate: '',
        params: {
          recommendUnitIdParent: '',
          recommendUnitId: '',
          education: '',
          major: '',
          extendExpiryDate: '',
          memberId: '',
          seal: '',
          memberCategory: ''
        },
        key: "name",
        customDataList: {},
        columns: [],
        selectKey: '',
        selectModel: false,
        showPicker: false,
        result: '',
        files: [],
        minDate: null,
      };
    },
    components: {
      vHead,
      [Uploader.name]: Uploader,
      [Toast.name]: Toast,
      [Field.name]: Field,
      [Button.name]: Button,
      [DatetimePicker.name]: DatetimePicker,
      [Popup.name]: Popup,
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [Picker.name]: Picker,
      [ActionSheet.name]: ActionSheet,
      [Dialog.Component.name]: Dialog.Component,
      [Radio.name]: Radio,
      [RadioGroup.name]: RadioGroup,
      [Overlay.name]: Overlay,
    },
    computed: {
      ...mapGetters(["isGroupMember", "dictFromCode"]),
      ...mapState(["userInfo"]),
      invoicesTypeDicMember() {
        return this.dictFromCode("INVOICE_TYPE_MEMBER");
      },
      invoicesTitleTypeList() {
        return this.dictFromCode("TITLE_TYPE");
      },
    },
    methods: {
      ...mapActions(["getDictionaryList"]),
      dateFormatString(value) {
        let date = new Date(value);
        let m = date.getMonth() + 1;
        let d = date.getDate();
        if (m >= 1 && m <= 9) {
          m = "0" + m;
        }
        if (d >= 0 && d <= 9) {
          d = "0" + d;
        }
        return date.getFullYear() + "-" + m + "-" + d;
      },
      onChange(picker, values, index) {
        // if (this.selectKey === "title") {
        //   picker.setColumnValues(1, values[0].children);
        // } else if (this.selectKey === "jg" || this.selectKey === "province") {
        //   let city = this.allAddress.filter((item) => {
        //     return item.parentId === values[0].id;
        //   });
        //   if (index === 0) {
        //     picker.setColumnValues(1, city);
        //   }
        // }
      },
      onCancel() {
        this.selectModel = false;
        this.selectKey = undefined;
      },
      beforeRead(file) {


      },
      reback() {
        this.$router.push({ name: 'extendApplyList' })
      },
      beforeFileUpload(file) {
        let handleResult = true;
        console.log('file', file)
        if (file.type == '') {
          Toast.fail("上传文件后缀名不正确");
          this.files = []
          handleResult = false;
          return false
        } else {
          let arr = ['.jpeg', '.jpg', '.png']
          const fileType = file.file.name.substring(file.file.name.lastIndexOf("."));
          if (arr.indexOf(fileType) == -1) {
            Toast.fail("上传文件类型不正确");
            this.files = []
            handleResult = false;
            return false
          }
        }
        if (file.file.size / 1024 > 1 * 1024) {
          Toast.fail("上传图片大小不能超过 1MB!");
          this.files = []
          handleResult = false;
          return false;
        }
        this.files.name = file.file.name; // 获取文件名
        this.files.type = file.file.type; // 获取类型
        this.imgPreview(file.file);
        return handleResult;
      },
      // 处理图片

      imgPreview(file) {
        this.loading = true
        let self = this
        let Orientation
        //   去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save   这里需要安装一下包
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, "Orientation")
        })
        // 看支持不支持FileReader
        if (!file || !window.FileReader) {
          Toast("请按规定上传文件")
          return
        }
        this.files.name = file.name // 获取文件名
        this.files.type = file.type // 获取类型
        if (/^image/.test(file.type)) {
          // 创建一个reader
          let reader = new FileReader()
          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file)
          // 读取成功后的回调
          reader.onloadend = function () {
            let result = this.result
            let img = new Image()
            img.src = result
            console.log("file.file", this.files)

            //判断图片是否大于500K,是就直接上传，反之压缩图片
            if (this.result.length <= 500 * 1024) {
              // 上传图片
              self.afterPortraitFile(this.result, true)
              // return this.successShow
            } else {
              img.onload = function () {
                let data = self.compress(img, Orientation)
                console.log(data)
                // 上传图片
                self.afterPortraitFile(data, true)
                // return this.successShow
              }
            }
          }
          return true
        } else {
          self.afterPortraitFile(file, false)
          // return this.successShow
          return true
        }
      },

      // 压缩图片
      compress(img, Orientation) {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        //瓦片canvas
        let tCanvas = document.createElement("canvas");
        let tctx = tCanvas.getContext("2d");
        // let initSize = img.src.length;
        let width = img.width;
        let height = img.height;
        //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio;
        if ((ratio = (width * height) / 4000000) > 1) {
          // console.log("大于400万像素");
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //    铺底色
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //如果图片像素大于100万则使用瓦片绘制
        let count;
        if ((count = (width * height) / 1000000) > 1) {
          // console.log("超过100W像素");
          count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
          //      计算每块瓦片的宽和高
          let nw = ~~(width / count);
          let nh = ~~(height / count);
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
              tctx.drawImage(
                img,
                i * nw * ratio,
                j * nh * ratio,
                nw * ratio,
                nh * ratio,
                0,
                0,
                nw,
                nh
              );
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        //修复ios上传图片的时候 被旋转的问题
        if (Orientation != "" && Orientation != 1) {
          switch (Orientation) {
            case 6: //需要顺时针（向左）90度旋转
              this.rotateImg(img, "left", canvas);
              break;
            case 8: //需要逆时针（向右）90度旋转
              this.rotateImg(img, "right", canvas);
              break;
            case 3: //需要180度旋转
              this.rotateImg(img, "right", canvas); //转两次
              this.rotateImg(img, "right", canvas);
              break;
          }
        }
        //进行最小压缩
        let ndata = canvas.toDataURL("image/jpeg", 0.3);
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        return ndata;
      },
      // 旋转图片
      rotateImg(img, direction, canvas) {
        //最小与最大旋转方向，图片旋转4次后回到原方向
        const min_step = 0;
        const max_step = 3;
        if (img == null) return;
        //img的高度和宽度不能在img元素隐藏后获取，否则会出错
        let height = img.height;
        let width = img.width;
        let step = 2;
        if (step == null) {
          step = min_step;
        }
        if (direction == "right") {
          step++;
          //旋转到原位置，即超过最大值
          step > max_step && (step = min_step);
        } else {
          step--;
          step < min_step && (step = max_step);
        }
        //旋转角度以弧度值为参数
        let degree = (step * 90 * Math.PI) / 180;
        let ctx = canvas.getContext("2d");
        switch (step) {
          case 0:
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            break;
          case 1:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, 0, -height);
            break;
          case 2:
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, -height);
            break;
          case 3:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, 0);
            break;
        }
      },
      //将base64转换为文件
      dataURLtoFile(dataurl) {
        var arr = dataurl.split(","),
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], this.files.name, {
          type: this.files.type,
        });
      },

      delFile(field, file) {
        let handleResult = true;
        this.params.seal = "";

        return handleResult;
      },

      afterPortraitFile(base64, stataus) {
        let params = new FormData()
        let file = ""
        if (stataus) {
          file = this.dataURLtoFile(base64)
        } else {
          file = base64
        }
        params.append("file", file)
        console.log("file", file)
        uploadFile(params).then((res) => {
          if (res.success) {
            this.$set(this.params, 'seal', res.result.id)
            Toast("上传成功")
            // this.successShow = true
          } else {
            file.message = "上传失败"
            Toast("上传失败")
            // this.successShow = false
          }
          this.loading = false
        })
      },
      onConfirm(item) {
        this.selectModel = false;
        this.params["recommendUnitId"] = item.code;
        this.params["recommendUnitIdParent"] = item.branchType;
      },
      onConfirmDate(time) {
        this.params.extendExpiryDate = this.dateFormatString(time);
        this.showPicker = false;
      },
      getRecommendBranchName(value) {
        let name = "";
        if (value && this.customDataList["recommendUnitId"]) {
          let obj = this.customDataList["recommendUnitId"].find(
            (item) => item.code === value
          );
          if (obj) {
            return obj.name;
          } else {
            return "";
          }
        }
        return name;
      },
      choiceOfYears(data) {
        this.params.education = data.value;
        this.education = data.name;
        this.show = false;
      },
      showRecommendBranchPicker(pickerField, dateField) {
        this.selectModel = true;
        // this.selectKey = "recommendUnitId";
        this.columns = this.customDataList["recommendUnitId"];
        // this.pickerField = pickerField;
      },
      submitCreate() {
        if (!this.params.recommendUnitId) {
          Toast("请选择推荐机构");
          return;
        }
        if (!this.params.major) {
          Toast("请输入所学专业");
          return;
        }

        if (!this.params.education) {
          Toast("请输入学历");
          return;
        }
        if (!this.params.extendExpiryDate) {
          Toast("请选择学生证有效期");
          return;
        }
        if (!this.params.seal) {
          Toast("请上传上传学生证明材料");
          return;
        }
        this.submit();
      },
      submit() {
        this.loading = true
        this.params.memberCategory = this.memberInfo.memberCategory
        this.params.memberId = getSessionStore("memberId")
        applyReduction(this.params).then(res => {
          if (res.success) {
            Toast.success("提交成功");
            this.loading = false
            this.$router.push('extendApplyList')

          } else {
            Toast.fail(res.message);
            this.loading = false
          }
        })
      },
    },
    created() {
      getBranchs().then((res) => {
        if (res.success) {
          res.result.forEach((itm) => (itm.value = itm.code));
          this.customDataList["recommendUnitId"] = res.result;
        }
      });
    },

    async mounted() {
      this.minDate = new Date();
      this.getDictionaryList();
      await getUser().then((res) => {
        this.memberInfo = res.result;
        let row = this.$route.query && this.$route.query.row
        if (row) {
          this.params = row
          this.params.extendExpiryDate = this.dateFormatString(row.extendExpiryDate);

          this.$set(this, "files", []);
          getBase64({ id: row.seal }).then(resp => {
            if (resp.success) {
              this.files.push({ content: resp.result })
            }
          })
        } else {
          this.params.recommendUnitIdParent = res.result.recommendUnitIdParent
          this.params.recommendUnitId = res.result.recommendUnitId
          this.params.major = res.result.major
          this.params.education = res.result.education
        }

      });
      getDictionaryByCode("EDUCATION").then((res) => {
        if (res.success) {
          this.options = res.result;
          let value = this.params.education
          var currentItem = res.result.find((item) => item.value == value);
          console.log('currentItem', currentItem)
          this.education = currentItem ? currentItem.name : "";
        }
      });
    },
  };
</script>

<style type="text/css" lang="less" scoped>
  .van-overlay {
    z-index: 999;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #ccc;
  }

  /deep/.van-cell--required .van-field__value {
    width: 92%;
  }

  /deep/.van-cell__value {
    color: black;
  }

  .contentOffLine {
    padding: 20px 18px;

    .van-cell {
      padding: 15px 0 0;
    }

    .van-cell--required::before {
      display: none;
    }

    /deep/.van-cell--required .van-cell__title::after {
      position: absolute;
      color: #ee0a24;
      font-size: 0.37333rem;
      content: "\00A0*";
    }
  }

  .cellRoadDiv>div {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }

  /deep/.van-field__label--top {
    width: 100%;
    text-align: left;
    margin-bottom: var(--van-padding-base);
    overflow-wrap: break-word;
  }

  .van-field {
    flex-wrap: wrap;
  }


  .cellRoadDiv /deep/.van-radio__icon {
    display: none;
  }

  .bottomButton {
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    text-align: center;
    background-color: #fff;
  }

  .cellRoadDiv .fontSix {
    text-align: right;
    font-size: 0.4rem;
    color: #646566;
  }
</style>